module.exports = __webpack_public_path__ + "img/icon-value-removed.0719e516.svg";